import { useState } from 'react';
import simulationService from '../services/simulationService';
import { GENERAL_USER_LDAP_GROUP } from '../types/constants';
import { hasLength } from '../utils/dataTransformations';

/**
 * Holds the groups picked for the next simulation. While a simulation is running
 * the active groups are shown instead, and switching off restores the real groups.
 */
export const useSimulationDraft = (simulatedLdap: string[]) => {
  const [draft, setDraft] = useState<string[]>([GENERAL_USER_LDAP_GROUP]);
  const isSimulating = hasLength(simulatedLdap);

  return {
    selected: isSimulating ? simulatedLdap : draft,
    selectGroups: setDraft,
    switchSimulation: (isOn: boolean) => simulationService.switchSimulation(isOn ? draft : []),
  };
};
